import { Icons, List, ListItemButton, ListItemDecorator } from '@healthinal/ui';
import { createLink, Link, useLocation } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ListItemButtonWrapper = forwardRef<HTMLAnchorElement, Record<string, unknown>>(
  function ListItemButtonWrapper(props, ref) {
    return <ListItemButton ref={ref} component={Link} {...props} />;
  },
);
const ListItemButtonLink = createLink(ListItemButtonWrapper);

export function ScreeningIndividualSideNavigation({
  screeningId,
  individualId,
}: {
  screeningId: string;
  individualId: string;
}) {
  const pathname = useLocation({ select: (location) => location.pathname });
  const personalDetailsPath = `/screening/${screeningId}/individuals/${individualId}`;
  const documentPath = `${personalDetailsPath}/document`;
  const isPersonalDetailsActive = pathname === personalDetailsPath || pathname === `${personalDetailsPath}/`;
  const isDocumentActive = pathname === documentPath;

  return (
    <List sx={{ maxWidth: 208, p: 0, '--ListItem-radius': '8px', '--List-gap': '4px', textDecoration: 'none' }}>
      <ListItemButtonLink to="/screening/$screeningId/individuals" params={{ screeningId }}>
        <ListItemDecorator>
          <Icons.ArrowBack />
        </ListItemDecorator>
        Zurück
      </ListItemButtonLink>
      <ListItemButtonLink
        to="/screening/$screeningId/individuals/$individualId"
        params={{ screeningId, individualId }}
        replace
        variant={isPersonalDetailsActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.AccountCircle />
        </ListItemDecorator>
        Personalien
      </ListItemButtonLink>
      <ListItemButtonLink
        to="/screening/$screeningId/individuals/$individualId/document"
        params={{ screeningId, individualId }}
        replace
        variant={isDocumentActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.Description />
        </ListItemDecorator>
        Dokumente
      </ListItemButtonLink>
    </List>
  );
}
